<template>
    <div id="user-notify">
        <van-collapse v-model="activeNames">
            <van-collapse-item v-for="(item, index) in notifyList" :name="index+1" :key="index">
                <div slot="title"><span class="tag">{{notifyList.length-index}}</span>{{item.title}}</div>
                <div  slot="default" @click="item.linkUrl&&item.linkUrl.length>0?toReturnPostage(item.linkUrl):''">
                    <div class="lineInDialog">
                        <label>内容：</label>
                        <span>{{ item.content }} </span>
                    </div>
                    <div class="lineInDialog">
                        <label>发布时间：</label>
                        <span>{{ item.createTime }} </span>
                    </div>
                </div>
            </van-collapse-item>
        </van-collapse>
        <div class="tips">---我是有底线的---</div>
    </div>
    
</template>
<script>
import {wxRequest} from '@/api/user.js'
export default {
    data(){
        return {
            notifyList: [],

            activeNames: ["1"],
        }
    },
    methods: {
        getNotifyListHandler(){
            let fd = new FormData();
            fd.append("iccid", localStorage.getItem("iccid"));
            wxRequest("sim/notice/myListPage", fd, "post").then(res => {
                if(res.data.code == 200){
                    this.notifyList = res.data.data.resultList;                  
                }
            })
        },

        toReturnPostage(url){
            this.$router.push({
                path: '/user/'+url
            }).catch(() => {

            });
        },
    },
    created(){
        this.getNotifyListHandler();
    }
}
</script>
<style lang="less" scoped>
@tag-color: #ec2038;

#user-notify{
      .tips {
                color: #a0a0a0;
                text-align: center;
                line-height: 28px;
            }





            
    .tag{
        display: inline-flex;
        align-items: center;
        padding: 0 .5em;
        margin: .2em .5em .2em 0;
        color: @tag-color;
        font-size: 10px;
        line-height: normal;
        border-radius: .5em;
        border: 1px solid @tag-color;
        vertical-align: text-top;
    }

    .lineInDialog{
        font-size: 12px;
        margin-bottom: .3em;
        color: #616161;
        label{
            width: 120px;
            font-weight: bold;
        }   
    } 
}


</style>
